import React, { useEffect } from 'react';

import { InfoMessage } from '@eika/attention-message';
import { MediumCenteredContainer } from '@eika/engine-view';
import { IconTypes } from '@eika/icon';

import { StringKeyValue } from '../../actions/types';
import { CardsReducer } from '../../reducers/cards';
import { StepsReducer } from '../../reducers/steps';
import parseUrlParams from '../../util/urlParams';
import ErrorMessage from '../Messages/ErrorMessage';
import About from './About/About';
import ContactInfo from './ContactInfo/ContactInfo';
import KycForm from './Kyc/KycForm';
import Sbl from './Sbl/Sbl';
import Summary from './Summary/Summary';

import Kredittkort from '../../assets/img/berikede-ikoner-kredittkort.svg';

interface Props {
    onAboutYouNextClick: () => void;
    onContactNextClick: (amountEnabled: boolean) => void;
    showDialog: () => void;
    text: StringKeyValue;
    steps: StepsReducer;
    cards: CardsReducer;
}

const CardApplicationComponent = (props: Props): JSX.Element => {
    const { text, steps, cards, onAboutYouNextClick, onContactNextClick } = props;
    const { currentStep } = steps;

    // Lets double check the params
    useEffect(() => {
        const urlParams = parseUrlParams();
        if (!urlParams.id) {
            const isGold = cards.paramType === 'gold';
            const isIncrease = cards.paramIncrease;
            if (
                (!isGold && !isIncrease && !cards.canHaveBusiness) ||
                (isGold && !isIncrease && !cards.canHaveGold) ||
                (isGold && isIncrease && !cards.hasGold) ||
                (!isGold && isIncrease && !cards.hasBusiness)
            ) {
                props.showDialog();
            }
        }
    }, [
        cards.canHaveBusiness,
        cards.canHaveGold,
        cards.hasBusiness,
        cards.hasGold,
        cards.paramIncrease,
        cards.paramType,
        props,
    ]);

    useEffect(() => {
        setTimeout(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 300);
    }, [currentStep]);

    const mainTitle = cards.paramType === 'business' ? text.mainHeaderBusiness : text.mainHeaderGold;

    return (
        <div className="credit-card-application">
            <MediumCenteredContainer>
                <>
                    {currentStep !== 4 && (
                        <div className="credit-card-application-form-header">
                            {currentStep === 1 && <img src={Kredittkort} alt="" style={{ maxWidth: '200px' }} />}
                            <h1>{cards.paramIncrease ? text.mainHeaderIncrease : mainTitle}</h1>
                        </div>
                    )}

                    {currentStep === 3 && !cards.paramIncrease && (
                        <div style={{ marginBottom: '50px' }}>
                            <InfoMessage
                                icon={IconTypes.LYSPAERE_24}
                                text={text.firstPageInfoText1}
                                clickableItem={<>{text.firstPageInfoText2}</>}
                            />
                        </div>
                    )}

                    {currentStep ? (
                        <>
                            {currentStep === 1 && <Sbl />}
                            {currentStep === 2 && <ContactInfo onContactNextClick={onContactNextClick} />}
                            {currentStep === 3 && <About onAboutYouNextClick={onAboutYouNextClick} />}
                            {currentStep === 4 && <KycForm />}
                            {currentStep === 5 && <Summary />}
                        </>
                    ) : (
                        <ErrorMessage
                            title={text.serviceErrorHeader}
                            textList={[text.serviceErrorText1, text.serviceErrorText2]}
                            useWrapper={false}
                        />
                    )}
                </>
            </MediumCenteredContainer>
        </div>
    );
};

export default CardApplicationComponent;
